import { Route } from '@angular/router';
import { NavbarComponent } from './components/main/header/navbar';

export const NAVBAR_ROUTE: Route = {
    path: '',
    component: NavbarComponent,
    outlet: 'navbar'
};

export const LAYOUT_ROUTES = [
    NAVBAR_ROUTE
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/main.route.ts